import { createAsyncThunk } from '@reduxjs/toolkit';
import type { NegociacaoGlobal } from '../../types/operacoes';
import {
  negociacoesGlobaisService,
  type NegociacoesGlobaisListResponse,
  type NegociacoesGlobaisParams,
  type NegociacoesGlobaisStats,
  type NegociacoesGlobaisStatsParams,
} from './services';

export const fetchNegociacoesGlobais = createAsyncThunk<
  NegociacoesGlobaisListResponse,
  NegociacoesGlobaisParams | undefined,
  { rejectValue: string }
>('negociacoesGlobais/fetchList', async (params, { rejectWithValue }) => {
  try {
    return await negociacoesGlobaisService.list(params);
  } catch (error) {
    return rejectWithValue(error instanceof Error ? error.message : 'Erro ao carregar negociações');
  }
});

export const fetchNegociacoesGlobaisStats = createAsyncThunk<
  NegociacoesGlobaisStats,
  NegociacoesGlobaisStatsParams | undefined,
  { rejectValue: string }
>('negociacoesGlobais/fetchStats', async (params, { rejectWithValue }) => {
  try {
    return await negociacoesGlobaisService.getStats(params);
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : 'Erro ao carregar estatísticas',
    );
  }
});

export const fetchNegociacaoGlobalById = createAsyncThunk<
  NegociacaoGlobal,
  string,
  { rejectValue: string }
>('negociacoesGlobais/fetchById', async (id, { rejectWithValue }) => {
  try {
    return await negociacoesGlobaisService.getById(id);
  } catch (error) {
    return rejectWithValue(error instanceof Error ? error.message : 'Erro ao carregar negociação');
  }
});
